(function () {
    'use strict';

    if (window.MetodoBluFlocculantCalculatorInitialized) return;
    window.MetodoBluFlocculantCalculatorInitialized = true;

    var STORAGE_KEY_PREFIX = 'flocculant-calculator';

    function getNumber(value) {
        var normalized = String(value).trim().replace(',', '.');
        var parsed = parseFloat(normalized);
        return isNaN(parsed) ? null : parsed;
    }

    function formatNumber(value, decimals) {
        if (value === null || typeof value === 'undefined' || isNaN(value)) return '—';
        var fixed = value.toFixed(decimals);
        return fixed.replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
    }

    function formatMessage(template, replacements) {
        return String(template || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (_, token) {
            return Object.prototype.hasOwnProperty.call(replacements, token) ? replacements[token] : '';
        });
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function decodeHtmlEntities(value) {
        if (!value) return value;
        var parser = document.createElement('textarea');
        parser.innerHTML = value;
        return parser.value;
    }

    function convertVolumeForDose(volumeM3, volumeUnit) {
        var normalizedUnit = String(volumeUnit || 'm3').toLowerCase();
        if (normalizedUnit === 'l' || normalizedUnit === 'lt' || normalizedUnit === 'liter' || normalizedUnit === 'liters' || normalizedUnit === 'litre' || normalizedUnit === 'litres') {
            return volumeM3 * 1000;
        }
        return volumeM3;
    }

    function calcVolume(state) {
        var depth = state.depth;
        if (!depth || depth <= 0) return 0;

        if (state.shape === 'rectangular') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return state.length * state.width * depth;
        }

        if (state.shape === 'oval') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return (Math.PI / 4) * state.length * state.width * depth;
        }

        if (state.shape === 'circular') {
            if (!state.diameter || state.diameter <= 0) return 0;
            return (Math.PI / 4) * state.diameter * state.diameter * depth;
        }

        if (state.shape === 'custom') {
            if (!state.surface || state.surface <= 0) return 0;
            return state.surface * depth;
        }

        return 0;
    }

    document.querySelectorAll('[data-flc-root]').forEach(function (root, rootIndex) {
        var shapeInputs = root.querySelectorAll('[data-flc-shape]');
        var inputEls = root.querySelectorAll('[data-flc-input]');
        var volumePreview = root.querySelector('[data-flc-volume-preview]');
        var volumeDisplay = root.querySelector('[data-flc-volume-display]');
        var resultsContainer = root.querySelector('[data-flc-results]');
        var storageKey = STORAGE_KEY_PREFIX + ':' + window.location.pathname + ':' + rootIndex;

        var config = {
            ready: root.getAttribute('data-flc-config-ready') === 'true',
            hasDosage: root.getAttribute('data-flc-has-dosage') === 'true',
            dosageAmount: getNumber(root.getAttribute('data-flc-dosage-amount')) || 0,
            dosageUnit: root.getAttribute('data-flc-dosage-unit') || 'g',
            dosagePerVolume: getNumber(root.getAttribute('data-flc-dosage-per-volume')) || 0,
            dosageVolumeUnit: root.getAttribute('data-flc-dosage-volume-unit') || 'm3',
            dosageTitleText: decodeHtmlEntities(root.getAttribute('data-flc-i18n-dosage-title')) || '',
            dosageTemplate: decodeHtmlEntities(root.getAttribute('data-flc-i18n-dosage-template')) || 'Add {{ amount }} {{ unit }}.',
            missingConfiguration: decodeHtmlEntities(root.getAttribute('data-flc-i18n-missing-configuration')) || 'This product is missing the dosing configuration.'
        };

        var state = {
            shape: 'rectangular',
            length: null,
            width: null,
            diameter: null,
            surface: null,
            depth: 1.2,
            volume: 0
        };

        function persistState() {
            try {
                var payload = {
                    shape: state.shape,
                    length: state.length,
                    width: state.width,
                    diameter: state.diameter,
                    surface: state.surface,
                    depth: state.depth
                };
                localStorage.setItem(storageKey, JSON.stringify(payload));
            } catch (error) {
                // Ignore unavailable storage.
            }
        }

        function restoreState() {
            try {
                var raw = localStorage.getItem(storageKey);
                if (!raw) return;

                var parsed = JSON.parse(raw);
                if (!parsed || typeof parsed !== 'object') return;

                if (parsed.shape && ['rectangular', 'oval', 'circular', 'custom'].indexOf(parsed.shape) !== -1) {
                    state.shape = parsed.shape;
                    shapeInputs.forEach(function (input) {
                        input.checked = input.value === parsed.shape;
                    });
                }

                inputEls.forEach(function (input) {
                    var key = input.getAttribute('data-flc-input');
                    if (!Object.prototype.hasOwnProperty.call(parsed, key)) return;
                    var value = parsed[key];
                    if (value === null || typeof value === 'undefined' || value === '') return;
                    input.value = value;
                    state[key] = getNumber(value);
                });
            } catch (error) {
                // Ignore invalid persisted payload.
            }
        }

        function updateShapeFields() {
            root.querySelectorAll('[data-flc-shape-fields]').forEach(function (group) {
                var shapes = (group.getAttribute('data-flc-shape-fields') || '').split(' ');
                var visible = shapes.indexOf(state.shape) !== -1;
                group.classList.toggle('is-hidden', !visible);
            });
        }

        function syncVolumePreview() {
            state.volume = calcVolume(state);

            if (volumePreview) volumePreview.hidden = state.volume <= 0;
            if (volumeDisplay) {
                volumeDisplay.textContent = state.volume > 0
                    ? formatNumber(state.volume, 1) + ' m³ (' + Math.round(state.volume * 1000) + ' L)'
                    : '—';
            }
        }

        function calcDosageResult() {
            if (!config.hasDosage || !state.volume) return null;
            if (!config.dosageAmount || !config.dosagePerVolume) return null;

            var volumeForDose = convertVolumeForDose(state.volume, config.dosageVolumeUnit);
            var dose = config.dosageAmount * (volumeForDose / config.dosagePerVolume);

            return {
                status: 'is-success',
                message: formatMessage(config.dosageTemplate, {
                    amount: '<span class="prc-result__amount">' + escapeHtml(formatNumber(dose, 2)) + '</span>',
                    unit: '<span class="prc-result__unit">' + escapeHtml(config.dosageUnit) + '</span>'
                }),
                isHtml: true
            };
        }

        function renderResultBlock() {
            var resultEl = root.querySelector('[data-flc-result="dosage"]');
            if (!resultEl) return false;

            var titleEl = resultEl.querySelector('[data-flc-result-title="dosage"]');
            var msgEl = resultEl.querySelector('[data-flc-result-message="dosage"]');
            var result = calcDosageResult();

            if (!result) {
                resultEl.hidden = true;
                return false;
            }

            resultEl.hidden = false;
            resultEl.classList.remove('is-error', 'is-warning', 'is-success');
            resultEl.classList.add(result.status);

            if (titleEl) titleEl.textContent = config.dosageTitleText || '';
            if (msgEl) {
                if (result.isHtml) {
                    msgEl.innerHTML = result.message;
                } else {
                    msgEl.textContent = result.message;
                }
            }

            return true;
        }

        function renderResults() {
            if (!config.ready || !state.volume || state.volume <= 0) {
                if (resultsContainer) resultsContainer.hidden = true;
                root.querySelectorAll('[data-flc-result]').forEach(function (el) { el.hidden = true; });
                return;
            }

            var anyVisible = renderResultBlock();
            if (resultsContainer) resultsContainer.hidden = !anyVisible;
        }

        shapeInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                state.shape = input.value;
                updateShapeFields();
                syncVolumePreview();
                renderResults();
                persistState();
            });
        });

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-flc-input');
            state[key] = getNumber(input.value);

            function handleValueChange() {
                state[key] = getNumber(input.value);

                var isInvalid = state[key] === null || state[key] <= 0;
                if (isInvalid) {
                    input.classList.add('is-invalid');
                } else {
                    input.classList.remove('is-invalid');
                }

                syncVolumePreview();
                renderResults();
                persistState();
            }

            input.addEventListener('input', handleValueChange);
            input.addEventListener('change', handleValueChange);
        });

        restoreState();

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-flc-input');
            if (state[key] !== null && typeof state[key] !== 'undefined') {
                input.value = state[key];
            }
        });

        updateShapeFields();
        syncVolumePreview();
        renderResults();
    });
})();